/* Štampa zavedenog dokumenta iz "Administracija > Štampa dokumentacije".

   Šablon nosi svoj A4 okvir (@page, margine, .dok padding) jer se isti sadržaj
   otvara i direktno sa servera. Zato ovde NE dodajemo konkurentski layout —
   samo doctype, charset i rezervni @page za starije snimljene dokumente. */
/* Dokument se otvara kroz window.open('') pa se HTML upisuje — takva stranica je
   about:blank i nema svoju ikonicu, pa preglednik posegne za /favicon.ico iz
   korena sajta. Tamo i dalje stoji podrazumevani CRA fajl, pa je u kartici
   stajao React logo. Zato ikonica ide izričito u zaglavlje dokumenta.

   Putanja mora biti APSOLUTNA: about:blank nema baznu adresu, pa se relativna
   "/noviLogo.png" ne bi razrešila ni u šta. */
const ikonica = () => `${window.location.origin}/noviLogo.png`;

const okvir = (naslov) => `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="utf-8">
<title>${naslov}</title>
<link rel="icon" href="${ikonica()}">
<style>
  /* Rezerva: važi samo za snapshotove zavedene pre nego što je okvir
     prebačen u sam šablon. Novi šabloni imaju svoj @page koji ovaj nadjačava. */
  @page { size: A4 portrait; margin: 18mm 16mm; }
  html, body { margin: 0; padding: 0; background: #fff; }
</style>
</head>
<body><div id="print-content"></div></body>
</html>`;

/* Zatvaranje odmah po štampi ume da prekine posao pre nego što ga preglednik
   pošalje, pa se prozor ostavlja korisniku. */
const odstampaj = (prozor) => {
    prozor.focus();
    prozor.print();
};

/* Rezervni put kad je popup blokiran: štampa iz skrivenog iframe-a u istoj
   stranici. Bez ovoga klik na "Štampaj" ne bi uradio ništa vidljivo. */
const stampajKrozIframe = (html, naslov) => {
    const okvirEl = document.createElement('iframe');
    okvirEl.setAttribute('aria-hidden', 'true');
    okvirEl.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    document.body.appendChild(okvirEl);

    const doc = okvirEl.contentWindow.document;
    doc.open();
    doc.write(okvir(naslov));
    doc.close();
    doc.getElementById('print-content').innerHTML = html;

    const pokreni = () => {
        okvirEl.contentWindow.focus();
        okvirEl.contentWindow.print();
        // iframe se uklanja tek pošto dijalog završi
        setTimeout(() => okvirEl.remove(), 60000);
    };

    if (doc.readyState === 'complete') setTimeout(pokreni, 150);
    else okvirEl.onload = () => setTimeout(pokreni, 150);
};

export default function handleStampaDokumenta(podaci) {
    if (!podaci || !podaci.htmlContent) return false;

    const naslov = podaci.zavedeniBroj ? `Dokument ${podaci.zavedeniBroj}` : 'Dokument';
    const prozor = window.open('', '_blank', 'width=1000,height=700');

    if (!prozor) {
        stampajKrozIframe(podaci.htmlContent, naslov);
        return true;
    }

    prozor.document.open();
    prozor.document.write(okvir(naslov));
    prozor.document.close();
    prozor.document.getElementById('print-content').innerHTML = podaci.htmlContent;

    /* Čeka se da prozor stvarno bude spreman — na sporijim mašinama fiksni
       timeout ume da otvori dijalog nad još praznom stranicom. */
    if (prozor.document.readyState === 'complete') setTimeout(() => odstampaj(prozor), 250);
    else prozor.onload = () => setTimeout(() => odstampaj(prozor), 250);

    return true;
}
